export default __webpack_public_path__ + "static/media/wreck.f016ec07.png";